import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { OverlayTrigger, Tooltip, Container } from 'react-bootstrap';
import InfiniteScroll from 'react-infinite-scroll-component';
import * as developmentOrderAction from '../../store/DevelopmentOrder.action';
import Loader from '../../../../Components/Utility/Loader/Loader';

function SubmitDownloadHistory() {
  const dispatch = useDispatch();
  const listInnerRef = useRef();
  const breakWord = 'break-word';
  const { t } = useTranslation('common');
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState({
    pageNumber: 1,
    pageSize: 20,
    totalCount: 0,
    scrollLoader: false,
    hasMore: false,
    dataList: [],
    isDataLoaded: false,
  });
  const reducers = useSelector((redState) => redState);
  const { Measuremets } = reducers;
  const { historyList, historyTotalCount } = Measuremets;

  const { pageNumber, pageSize } = state;

  const getSubmitDownloadList = async () => {
    setLoading(true);
    const reqObj = {
      pageNumber,
      pageSize,
    };
    await dispatch(developmentOrderAction.getSubmitHistory(reqObj));
    setLoading(false);
  };

  const handleNextPageInScroll = async () => {
    const nextPageIndex = pageNumber + 1;
    setState((prevState) => ({
      ...prevState,
      pageNumber: nextPageIndex,
    }));

    const params = {
      pageNumber: nextPageIndex,
      pageSize,
    };

    await dispatch(developmentOrderAction.getSubmitHistory(params));
  };

  useEffect(() => {
    const init = async () => {
      getSubmitDownloadList();
    };
    init();
  }, []);

  useEffect(() => {
    if (Array.isArray(historyList)) {
      setState((prev) => ({
        ...prev,
        dataList: [...state.dataList, ...historyList],
        hasMore: historyTotalCount > historyList.length,
      }));
    }
  }, [historyList, historyTotalCount]);

  const renderError = (error) => {
    if (error === 'Error: SWITCH_OFF' || error === 'Error: SET_COMPONENT_TYPE') {
      return t('MULTI_SUBMIT_DOWNLOAD_LOGS.ERRORS.SWITCH_OFF');
    }
    if (error === 'Error: FILE_NOT_EXISTS') {
      return t('MULTI_SUBMIT_DOWNLOAD_LOGS.ERRORS.FILE_NOT_EXISTS');
    }
    if (typeof error === 'string' && error.startsWith('Error: MODULE_BLANK:')) {
      const modules = error.replace('Error: MODULE_BLANK:', '').trim();
      return t('MULTI_SUBMIT_DOWNLOAD_LOGS.ERRORS.MODULE_BLANK', { modules });
    }
    return t('MULTI_SUBMIT_DOWNLOAD_LOGS.ERRORS.DIFFERENT');
  };

  return (
    <div>
      <div className="page-title-filter sticky">
        <div className="title-container d-flex align-items-center">
          <h4 className="title">{t('FILTER.SUBMIT_DOWNLOAD_HISTORY')}</h4>
        </div>
        <div className="d-flex submit-log justify-content-end">
          <Link className="cursor-pointer text-dark text-decoration-none btn btn-page-filter multi-download-log" to="/multi-download-logs">
            {t('MULTI_SUBMIT_DOWNLOAD_LOGS.MULTI_DOWNLOAD_LOGS')}
          </Link>
          <Link className="cursor-pointer text-dark text-decoration-none btn btn-page-filter multi-download-log" to="/multi-submit-download-logs">
            {t('MULTI_SUBMIT_DOWNLOAD_LOGS.MULTI_SUBMISSION_LOGS')}
          </Link>
        </div>
      </div>

      <div>
        {loading ? (
          <Loader />
        ) : (
          <Container fluid className="pt-4">
            <div
              id="scrollableDiv_PIM"
              style={{
                height: 'calc(100vh - 150px)',
                overflow: 'auto',
              }}
              ref={listInnerRef}
            >
              <InfiniteScroll
                dataLength={state?.dataList?.length}
                hasMore={state?.hasMore}
                next={handleNextPageInScroll}
                scrollableTarget="scrollableDiv_PIM"
                className="fixed-col-container"
              >
                <table className="table fixed-table-th custom-table layout-fixed font-13 text-center">
                  <thead>
                    <tr>
                      <th className="w-80px w-xs-150px">{t('FILTER.PRODUCT_NO')}</th>
                      <th className="w-80px w-xs-150px">{t('COSTING.SUPPLIER')}</th>
                      <th className="w-80px w-xs-150px">{t('FILTER.COSTING_PUR')}</th>
                      <th className="w-80px w-xs-150px">{t('FILTER.TECHNICAL_PACKAGE')}</th>
                      <th className="w-80px w-xs-150px">{t('FILTER.TECH_PACK')}</th>
                      <th className="w-80px w-xs-150px">{t('FILTER.OTHER')}</th>
                      <th className="w-80px w-xs-150px">{t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_DOWNLODS_PRODUCT.PURCHASE_ORDERS')}</th>
                      <th className="w-80px w-xs-150px">{t('FILTER.REQUEST_TYPE')}</th>
                      <th className="w-80px w-xs-150px">{t('TAKING_DATES.STATES')}</th>
                      <th className="w-80px">{t('COSTING_TO_DO_LIST.ACTION')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {state?.dataList?.map((data) => {
                      const errorLines = [];
                      if (data?.errorLog) errorLines.push(renderError(data.errorLog));
                      if (data?.costingErrorLog) {
                        errorLines.push(t('MULTI_SUBMIT_DOWNLOAD_LOGS.ERRORS.COSTING_FAILED', { reason: data.costingErrorLog }));
                      }
                      if (data?.inviteErrorLog) {
                        errorLines.push(t('MULTI_SUBMIT_DOWNLOAD_LOGS.ERRORS.INVITE_FAILED', { reason: data.inviteErrorLog }));
                      }
                      if (data?.sampleErrorLog) {
                        errorLines.push(t('MULTI_SUBMIT_DOWNLOAD_LOGS.ERRORS.SAMPLE_FAILED', { reason: data.sampleErrorLog }));
                      }
                      return (
                      <tr key={data?._id}>
                        <td style={{ wordBreak: breakWord }}>{data?.devOrderId?.number} </td>
                        <td>{data?.supplier} </td>
                        <td style={{ wordBreak: breakWord }} className="text-capitalize">
                          {data?.costing?.join(',')}{' '}
                        </td>
                        <td style={{ wordBreak: breakWord }} className="text-capitalize">
                          {data?.techPack?.join(',') || '--'}{' '}
                        </td>
                        <td>{`${data?.isTechPackCombined === true ? 'Yes' : 'No'}` || '--'} </td>
                        <td style={{ wordBreak: breakWord }} className="text-capitalize">
                          {data?.others?.join(',') || '--'}{' '}
                        </td>
                        <td style={{ wordBreak: breakWord }} className="text-capitalize">
                          {Array.isArray(data?.poNoIds) && data.poNoIds.length
                            ? data.poNoIds
                                .map((po) => po?.purchaseOrderNumber || po?.poOrderNo)
                                .filter(Boolean)
                                .join(', ')
                            : '--'}
                        </td>
                        <td>{data?.requestType || '--'} </td>
                        <td>{data?.status || '--'} </td>
                        <td>
                          <div className="action-btns d-flex align-items-center" style={{ 'margin-left': '30%' }}>
                            <div className="info-container testing-action-spaceremoval">
                              <span className="icon-info  f-18" />
                              <div className="info-content">
                                <p className="mb-1">
                                  <b>{t('PROGRESS_INDICATOR.CREATE')}&nbsp;</b>
                                  {`${data?.createdBy?.firstName} ${data?.createdBy?.lastName}`} {moment(data?.createdAt).format('DD-MMMM-YYYY hh:mm A')}
                                </p>
                              </div>
                            </div>
                            {data?.message && (
                              <div>
                                <OverlayTrigger
                                  placement="bottom"
                                  overlay={
                                    <Tooltip className="text-tooltip" id="tooltip_description">
                                      {data.message}
                                    </Tooltip>
                                  }
                                >
                                  <button
                                    style={{
                                      'margin-top': '5px',
                                      'margin-left': '10px',
                                    }}
                                    className="btn p-0"
                                    type="button"
                                  >
                                    <i className="icon-Chat f-18" />
                                  </button>
                                </OverlayTrigger>
                              </div>
                            )}
                            {errorLines.length > 0 && (
                              <div>
                                <OverlayTrigger
                                  placement="bottom"
                                  overlay={
                                    <Tooltip className="text-tooltip" id="tooltip_errors">
                                      {errorLines.map((line, idx) => (
                                        <div key={idx} className="mb-1">
                                          {line}
                                        </div>
                                      ))}
                                    </Tooltip>
                                  }
                                >
                                  <button
                                    title="Error"
                                    aria-label="Error Log"
                                    style={{
                                      'margin-top': '5px',
                                      'margin-left': '10px',
                                    }}
                                    className="btn p-0"
                                    type="button"
                                  >
                                    <i className="icon-Information f-18" />
                                  </button>
                                </OverlayTrigger>
                              </div>
                            )}
                          </div>
                        </td>
                      </tr>
                      );
                    })}
                  </tbody>
                </table>
              </InfiniteScroll>
            </div>
          </Container>
        )}
      </div>
    </div>
  );
}

export default SubmitDownloadHistory;
